import React, { useEffect, useState } from 'react'
import styles from '../styles.module.scss'
import CustomSelect from '../../../components/CustomSelect'

import Leaf from '../../../components/Leaf'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import { getCLasses, getParallels, getScheduleVariants, getSchoolYears, getShifts, getStudyForms, getStudySteps } from '../../../actions/common'
import queryString from 'query-string';
import { useFormik } from 'formik'
import { getScheduleDO, getScheduleDOByYear } from '../../../actions/schedulingDO'
import { getStagesStudy } from '../../../actions/stagesStudy'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import { Checkbox } from '../../../components/ModalInputs'
import { getSchedule } from '../../../actions/scheduling'
import Button from '../../../components/Button'
import { getSubjectsExtraEdu } from '../../../actions/directoryExtraEducation'
// import { arrayForSelect } from '../../utils/arrayForSelect'



export default function Form() {

  const dispatch = useDispatch()
  const { schoolYears, shifts, scheduleVariants, studyForms, parallels, classes } = useSelector(state => state.common)
  const { stageStudyList } = useSelector(state => state.stages_study)
  const { extraEduList } = useSelector(state => state.directoryExtraEducation)

  const navigate = useNavigate()
  const location = useLocation()

  const paramsForm = {}

  const {
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: paramsForm,
    onSubmit: () => { dispatch(getSchedule(values.sh_var_id, { course_type: 1, ...values })) }
  })

  useEffect(() => {
    !schoolYears.length && dispatch(getSchoolYears())
    !shifts && dispatch(getShifts())
    !studyForms && dispatch(getStudyForms())
    !stageStudyList && dispatch(getStagesStudy())
    !parallels && dispatch(getParallels())
    !classes && dispatch(getCLasses())
    dispatch(getScheduleDO())
    dispatch(getSubjectsExtraEdu({ statuses: 'Идет' })) // ПРЕДМЕТЫ  для Дисциплина
  }, [])

  useEffect(() => {
    if (!values.scYear) return;
    dispatch(getScheduleVariants(values.scYear))

    dispatch(getScheduleDO(values.scYear))
    setFieldValue('sh_var_id', null)
  }, [values.scYear])

  return (
    <div className={styles.wrapperPanel}>

      <div className={styles.inputsRow}>
        <CustomSelect
          title="Учебный год"
          valuesName="scYear"
          value={values.scYear}
          options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
          setFieldValue={setFieldValue}
        />
        <CustomSelect
          title="Вариант расписания"
          valuesName="sh_var_id"
          value={values.sh_var_id}
          options={scheduleVariants && arrayForSelect(scheduleVariants, 'sh_var_name', 'sh_var_id')}
          setFieldValue={setFieldValue}
        />
        <CustomSelect
          title="Форма обучения"
          valuesName="f_studyform"
          options={studyForms && arrayForSelect(studyForms, 'name', 'f_studyform')}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className={styles.inputsRow}>
        <CustomSelect
          title="Ступень обучения"
          valuesName="f_studysteps"
          options={stageStudyList && arrayForSelect(stageStudyList, 'name', 'f_studysteps')}
          setFieldValue={setFieldValue}
        />
        <CustomSelect
          title="Смена"
          valuesName="shift"
          options={shifts && arrayForSelect(shifts, 'name', 'sid')}
          setFieldValue={setFieldValue}
        />
      </div>
      <div className={styles.inputsRow}>
        <CustomSelect
          title="Дисциплина"
          valuesName="course"
          options={extraEduList && arrayForSelect(extraEduList, 'name', 'xp_key')}
          setFieldValue={setFieldValue}
        />
        <Checkbox
          label='Тестовая отправка'
          name='test_mail'
          checked={values.test_mail}
          onChange={() => setFieldValue('test_mail', !values.test_mail)}
        />
        <Button className={styles.buttonDO} disabled={!values.sh_var_id} onClick={handleSubmit}>Получить расписание</Button>
      </div>
    </div>
  )
}
